import React from 'react'
import PropTypes from 'prop-types'
import { Box, makeStyles } from '@material-ui/core'
import { FiberManualRecord } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import { selectSegmentation } from '../selectors'

const useStyles = makeStyles((theme) => ({
  root: ({ color }) => ({
    backgroundColor: `${color}60`,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 4,
    fontSize: 14,
    width: 'fit-content',
    maxWidth: '100%'
  }),
  icon: ({ color }) => ({
    fontSize: 12,
    fill: color
  }),
  label: {
    lineHeight: '12px',
    ...theme.lineLimit(),
    wordBreak: 'break-all'
  }
}))

const SegmentTag = ({ segment: segmentName }) => {
  const allSegments = useSelector(selectSegmentation)
  const segment = allSegments[segmentName]
  const classes = useStyles(segment)

  return (
    <Box className={classes.root}>
      <FiberManualRecord className={classes.icon} />
      <span className={classes.label}>{segment.name}</span>
    </Box>
  )
}

SegmentTag.propTypes = {
  segment: PropTypes.string.isRequired
}

export default SegmentTag

// segmentTag template html
export function segmentTagHtml(formatedStoreName, segmentation) {
  const segmentationStyle =
    'display: flex; align-items: center; gap: 4px; padding: 2px 8px; border-radius: 4px; font-size: 12px; width: fit-content;'
  const segmentationIconStyle = 'width: 8px; height: 8px; border-radius: 100%;'
  const segmentationTagStyle = 'line-height: 12px;'

  return segmentation
    ? `<div class="map-title">
      <div class="segmentation" style="background-color: ${segmentation.color}60;  ${segmentationStyle}">
        <div class="segmentation_icon" style="background-color: ${segmentation.color}; ${segmentationIconStyle}"></div>
        <div class="segmentation_tag" style="${segmentationTagStyle}">${segmentation.name}</div>
      </div>
      <span>${formatedStoreName}</span>
    </div>
  `
    : `<div class="map-title">
  <span>${formatedStoreName}</span>
</div>`
}
